export enum ImageActionType {
  ShowImage = 'ShowImage',
  UpgradePage = 'UpgradePage',
  SafeMode = 'SafeMode',
  UploadImage = 'UploadImage',
  OpenInBrowser = 'OpenInBrowser',
  NoAction = 'NoAction',
  ShowUnavailablePopup = 'ShowUnavailablePopup',
}
